document.addEventListener("DOMContentLoaded", function () {
  var splideCarousels = document.getElementsByClassName("splide-content");
  Array.from(splideCarousels).forEach(function (element, index) {
    var uniqueClass = "splide-content-" + index;
    element.classList.add(uniqueClass);

    var splideCarousel = new Splide("." + uniqueClass, {
      gap: 32,
      rewind: true,
      drag: true,
      pagination: false,
      arrows: true,
      // autoWidth: true,
      // type: "loop",
      // focus: "center",
      perPage: 3,
      perMove: 1,
      breakpoints: {
        1200: {
          destroy: true,
        },
      },
    });
    splideCarousel.mount();
  });

  var splideImages = document.getElementsByClassName("splide-logo");
  Array.from(splideImages).forEach(function (element, index) {
    var uniqueClass = "splide-logo-" + index;
    element.classList.add(uniqueClass);

    var splideImage = new Splide("." + uniqueClass, {
      gap: 32,
      rewind: true,
      drag: true,
      pagination: false,
      arrows: true,
      perPage: 3,
      perMove: 3,
      breakpoints: {
        1024: {
          perPage: 2,
          perMove: 2,
          gap: 24,
        },
        580: {
          perPage: 1,
          perMove: 1,
        },
      },
    });
    splideImage.mount();
  });
});
